import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { WbSafeNunjucksApi, wbSafeNunjucksApiRef } from '../apis';
import { useEffect, useState, useMemo } from 'react';

export const parseDisplayField = (
  nunjucksApi: WbSafeNunjucksApi,
  entity: Record<string, any>,
  displayField?: string,
) => {
  if (!displayField) return undefined;

  return nunjucksApi.render(displayField, entity);
};

// Hook to load nunjucks templates and track their loading state
export const useLoaderNunjucks = (paths?: string[]) => {
  const nunjucksApi = useApi(wbSafeNunjucksApiRef);

  const [loadedHash, setLoadedHash] = useState<string | undefined>(undefined);

  const experimentalNunjucksRendering =
    useApi(configApiRef).getOptionalBoolean(
      'mesh.experimentalNunjucksRendering',
    ) ?? true;

  // create a hash of the paths to track loading state, if paths change the hash will change and trigger the effect to load the new templates
  const hash = useMemo(() => (paths ? paths.join(',') : ''), [paths]);

  const normalizedPaths = useMemo(
    () => (hash ? hash.split(',') : undefined),
    [hash],
  );

  useEffect(() => {
    let cleanupFn: any;
    if (normalizedPaths && experimentalNunjucksRendering) {
      cleanupFn = nunjucksApi.load(normalizedPaths);
    }
    setLoadedHash(hash);
    return () => {
      if (cleanupFn) {
        cleanupFn();
      }
    };
  }, [experimentalNunjucksRendering, normalizedPaths, hash, nunjucksApi]);

  const returnValue = useMemo(() => {
    return { isReady: loadedHash === hash };
  }, [loadedHash, hash]);

  return returnValue;
};
